import { trackMoengageEvents } from '../../analytics_wrapper';
import { LocalSessionKey } from '../../app/burger-king-lib/constants/app-constants';
import { SessionStorage } from '../../app/burger-king-lib/utils/storage.web';
import { extractCartData } from '../../app/utils/services';
import { ANALYTICS_EVENTS } from './constants';

const commonData = {
  orderMode: () => SessionStorage.get(LocalSessionKey.ORDER_TYPE) || '',
  addressInfo: () => {
    const info = SessionStorage.get(LocalSessionKey.RESTAURANT_DETAIL);
    return {
      lat: info?.lat || 0,
      long: info?.long || 0,
      outletId: info?.outlet_id || '',
      outletName: info?.outlet_name || '',
      address: info?.address || '',
      dineinEstimatedTime: info?.dinein_estimated_time || 0,
      location: info?.location || '',
      city: info?.city || '',
      region: info?.region || ''
    };
  },
  getPageName: value => (value === '/' ? 'home' : value),
  getCrowns: () => window.localStorage.getItem(LocalSessionKey.CROWNS) || 0
};

const MOENGAGE_EVENTS_TRACKER = {
  homepage_load: async ({ platform, deviceName, utm_source, utm_campaign }) =>
    trackMoengageEvents(ANALYTICS_EVENTS.HOMEPAGE_LOAD, {
      platform,
      deviceName,
      utm_source,
      utm_campaign
    }),
  location: async ({ location = '', lat = 0, long = 0 }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.LOCATION, {
      location,
      lat,
      long
    });
  },
  delivery_mode: async ({ order_mode = '' }) =>
    trackMoengageEvents(ANALYTICS_EVENTS.DELIVERY_MODE, { order_mode }),
  select_location: async ({
    order_mode = commonData.orderMode(),
    address = commonData.addressInfo().address,
    city = commonData.addressInfo().city,
    pincode = '',
    state = ''
  }) => {
    if (typeof address === 'string' && !pincode) {
      const match = address.match(/\b\d{6}\b/);
      pincode = match ? match[0] : '';
    }

    trackMoengageEvents(ANALYTICS_EVENTS.SELECT_LOCATION, {
      order_mode,
      address,
      city,
      pincode,
      state
    });
  },
  product_search: async ({
    order_mode = commonData.orderMode(),
    store_id = commonData.addressInfo().outletId,
    city = commonData.addressInfo().city,
    store_name = commonData.addressInfo().outletName,
    keywords = '',
    product_name = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.PRODUCT_SEARCH, {
      order_mode,
      store_id,
      city,
      keywords,
      store_name,
      product_name
    });
  },
  banner_clicked: async ({
    banner_name = '',
    banner_type = '',
    category_type = '',
    page_name = '',
    banner_location = commonData.addressInfo().location,
    order_mode = commonData.orderMode(),
    store_id = commonData.addressInfo().outletId,
    store_name = commonData.addressInfo().outletName
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.BANNER_CLICKED, {
      banner_location,
      banner_name,
      banner_type,
      category_type,
      order_mode,
      store_name,
      store_id,
      page_name
    });
  },
  hamburger_menu: async ({
    order_mode = commonData.orderMode(),
    page_name = '',
    button_clicked = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.HAMBURGER_MENU, {
      order_mode,
      page_name: commonData.getPageName(page_name),
      button_clicked
    });
  },
  delivery_service: async ({
    order_mode = commonData.orderMode(),
    store_name = commonData.addressInfo().outletName,
    city = commonData.addressInfo().city,

    isServicable = false,
    outlet_message = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.DELIVERY_SERVICE, {
      order_mode,
      city,
      isServicable,
      store_name,
      outlet_message
    });
  },
  explore_menu: async ({
    order_mode = commonData.orderMode(),
    page_name = '',
    category_type = '',
    category_name = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.EXPLORE_MENU, {
      order_mode,
      page_name: commonData.getPageName(page_name),
      category_type,
      category_name
    });
  },
  store_search: async ({
    order_mode = commonData.orderMode(),
    store_id = commonData.addressInfo().outletId,
    search_text = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.STORE_SEARCH, {
      order_mode,
      search_text,
      store_id
    });
  },
  category_plp: async ({
    order_mode = commonData.orderMode(),
    crown_points = commonData.getCrowns(),
    store_name = commonData.addressInfo().outletName,
    store_id = commonData.addressInfo().outletId,
    category_name = '',
    category_discount_type = '',
    category_discount_value = 0
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.CATEGORY_PLP, {
      order_mode,
      category_name,
      crown_points,
      store_name,
      store_id,
      category_discount_type,
      category_discount_value
    });
  },
  product_click: async ({
    order_mode = commonData.orderMode(),
    city = commonData.addressInfo().city,
    store_name = commonData.addressInfo().outletName,
    store_id = commonData.addressInfo().outletId,
    category_name = '',
    category_id = '',
    product_name = '',
    product_id = '',
    product_type = '',
    price = 0,
    image_url = '',
    crown_points = commonData.getCrowns(),
    region = commonData.addressInfo().region,
    coupon_name = '',
    discount_value = 0
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.PRODUCT_CLICK, {
      order_mode,
      city,
      store_name,
      store_id,
      category_name,
      category_id,
      product_name,
      product_id,
      product_type,
      price,
      image_url,
      crown_points,
      region,
      coupon_name,
      discount_value
    });
  },
  veg_nonveg_filter: async ({
    veg_flag = false,
    nonveg_flag = false,
    category_name = '',
    order_mode = commonData.orderMode(),
    city = commonData.addressInfo().city,
    store_name = commonData.addressInfo().outletName,
    store_id = commonData.addressInfo().outletId
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.VEG_NONVEG_FILTER, {
      veg_flag,
      nonveg_flag,
      order_mode,
      city,
      store_name,
      store_id,
      category_name
    });
  },
  add_to_cart: async ({
    order_mode = commonData.orderMode(),
    store_name = commonData.addressInfo().outletName,
    crown_points = commonData.getCrowns(),
    store_id = commonData.addressInfo().outletId,
    product_name = '',
    product_price = 0,
    product_quantity = 1,
    category_id = '',
    category_name = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.ADD_TO_CART, {
      order_mode,
      store_id,
      product_name,
      product_price,
      product_quantity,
      crown_points,
      store_name,
      category_id,
      category_name
    });
  },
  remove_from_cart: async ({
    order_mode = commonData.orderMode(),
    store_name = commonData.addressInfo().outletName,
    crown_points = commonData.getCrowns(),
    store_id = commonData.addressInfo().outletId,
    product_name = '',
    product_price = 0,
    product_quantity = 1,
    category_id = '',
    category_name = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.REMOVE_FROM_CART, {
      order_mode,
      store_id,
      product_name,
      product_price,
      product_quantity,
      crown_points,
      store_name,
      category_id,
      category_name
    });
  },
  view_cart: async function moengageViewCartEvent(cartContentData) {
    if (!cartContentData) return;

    const moengagePayload = {
      order_mode: commonData.orderMode(),
      store_id: commonData.addressInfo().outletId,
      product_name: [],
      product_price: [],
      category_id: [],
      category_name: [],
      product_quantity: [],
      total_quantity: 0,
      store_name: commonData.addressInfo().outletName,
      discount: cartContentData?.discount_value,
      delivery_fee: cartContentData?.delivery_charges,
      taxes_and_charges: cartContentData?.total_tax,
      total_payable: cartContentData?.total_payable_amount
    };

    if (cartContentData?.cart_items) {
      const cartList = Object.values(cartContentData?.cart_items);
      if (cartList.length > 0) {
        moengagePayload.total_quantity = cartList.length;
        cartList.forEach(item => {
          moengagePayload.product_name = [
            ...(Array.isArray(moengagePayload.product_name)
              ? moengagePayload.product_name
              : []),
            item.product_name || ''
          ];

          moengagePayload.product_price = [
            ...(Array.isArray(moengagePayload.product_price)
              ? moengagePayload.product_price
              : []),
            `${item.total_price || ''}`
          ];

          moengagePayload.category_id = [
            ...(Array.isArray(moengagePayload.category_id)
              ? moengagePayload.category_id
              : []),
            item.category_id || ''
          ];

          moengagePayload.category_name = [
            ...(Array.isArray(moengagePayload.category_name)
              ? moengagePayload.category_name
              : []),
            item.category_name || ''
          ];
          moengagePayload.product_quantity = [
            ...(Array.isArray(moengagePayload.product_quantity)
              ? moengagePayload.product_quantity
              : []),
            item.quantity || 0
          ];
        });
      }
    }

    trackMoengageEvents(ANALYTICS_EVENTS.VIEW_CART, moengagePayload);
  },
  view_offers: async ({
    order_mode = commonData.orderMode(),
    store_id = commonData.addressInfo().outletId
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.VIEW_OFFERS, {
      order_mode,
      store_id
    });
  },
  coupon_apply: async ({
    order_mode = commonData.orderMode(),
    cart_value = 0,
    coupon_name = '',
    isSuccessfull = false,
    discount_value = 0,
    coupon_apply_time = null,
    date_validity = null
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.COUPON_APPLY, {
      order_mode,
      cart_value,
      coupon_name,
      isSuccessfull,
      discount_value,
      coupon_apply_time,
      date_validity
    });
  },
  coupon_remove: async ({
    order_mode = commonData.orderMode(),
    cart_value = 0,
    coupon_name = '',
    isSuccessfull = false,
    discount_value = 0,
    coupon_apply_time = null,
    date_validity = null
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.COUPON_REMOVE, {
      order_mode,
      cart_value,
      coupon_name,
      isSuccessfull,
      discount_value,
      coupon_apply_time,
      date_validity
    });
  },
  add_address: async ({
    city = commonData.addressInfo().city,
    address = '',
    pincode = '',
    state = '',
    lat = null,
    long = null,
    landmark = '',
    save_as = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.ADD_ADDRESS, {
      address,
      city,
      pincode,
      state,
      lat,
      long,
      landmark,
      save_as
    });
  },
  set_delivery_address: async ({
    order_mode = commonData.orderMode(),
    city = '',
    lat = null,
    long = null,
    address = '',
    pincode = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.SET_DELIVERY_ADDRESS, {
      order_mode,
      city,
      lat,
      long,
      address,
      pincode
    });
  },
  checkout: async ({ cartData = {} }) => {
    const moengagePayload = {
      order_mode: commonData.orderMode(),
      store_id: commonData.addressInfo().outletId,
      city: commonData.addressInfo().city,
      store_name: commonData.addressInfo().outletName,
      region: commonData.addressInfo().region,
      product_name: [],
      product_price: [],
      product_quantity: [],
      total_quantity: 0,
      category_id: [],
      category_name: [],
      discount: cartData?.discount_value,
      delivery_fee: cartData?.delivery_charges,
      taxes_and_charges: cartData?.total_tax,
      cart_value: cartData?.total_payable_amount,
      total_payable_amount: cartData?.total_payable_amount
    };

    const result = extractCartData(cartData);

    trackMoengageEvents(ANALYTICS_EVENTS.CHECKOUT, {
      ...moengagePayload,
      ...result
    });
  },
  make_payment: async ({
    order_mode = commonData.orderMode(),
    city = commonData.addressInfo().city,
    store_id = commonData.addressInfo().outletId,
    order_id = '',
    cart_id = '',
    cart_value = 0,
    coupon_name = '',
    coupon_value = '',
    coupon_id = '',
    payment_mode = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.MAKE_PAYMENT, {
      order_mode,
      city,
      store_id,
      order_id,
      cart_id,
      cart_value,
      coupon_name,
      coupon_value,
      coupon_id,
      payment_mode
    });
  },
  purchase_completed: async ({
    order_mode = commonData.orderMode(),
    city = commonData.addressInfo().city,
    store_id = commonData.addressInfo().outletId,
    store_name = commonData?.addressInfo().outletName,

    order_id = '',
    cart_id = '',
    cart_value = 0,
    coupon_name = '',
    coupon_value = '',
    coupon_id = '',
    total_payable_amount = 0,
    total_price = 0,
    total_tax_amount = 0,
    delivery_charges = 0,
    packing_charges = 0,
    coupon_code = '',
    discount = 0,
    discount_value = 0,
    crown_points = 0,
    region = '',
    balance_crowns = 0,
    crowns_earned = 0,
    first_order = false,
    product_name = [],
    product_price = [],
    category_id = [],
    category_name = [],
    product_quantity = [],
    total_quantity = 0,
    has_purchased_dessert = false,
    has_purchased_coffee = false,
    has_purchased_breakfast = false,
    has_purchased_core = false
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.PURCHASE_COMPLETED, {
      order_mode,
      city,
      store_id,
      order_id,
      cart_id,
      cart_value,
      coupon_name,
      coupon_value,
      coupon_id,
      total_payable_amount,
      total_price,
      total_tax_amount,
      delivery_charges,
      packing_charges,
      coupon_code,
      discount,
      discount_value,
      crown_points,
      store_name,
      region,
      balance_crowns,
      crowns_earned,
      first_order,
      product_name,
      product_price,
      category_id,
      category_name,
      product_quantity,
      total_quantity,
      has_purchased_dessert,
      has_purchased_coffee,
      has_purchased_breakfast,
      has_purchased_core
    });
  },
  login_attempt: async ({
    login_method = '',
    mobie_number = '',
    city = commonData.addressInfo().city
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.LOGIN_ATTEMPT, {
      login_method,
      mobie_number,
      city
    });
  },
  get_otp: async ({ status = '', city = commonData.addressInfo().city }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.GET_OTP, {
      status,
      city
    });
  },
  resend_otp: async ({ status = '', city = commonData.addressInfo().city }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.RESEND_OTP, {
      status,
      city
    });
  },
  verify_otp: async ({
    status = '',
    reason = '',
    city = commonData.addressInfo().city
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.VERIFY_OTP, {
      status,
      reason,
      city
    });
  },

  login_successful: async ({
    status = '',
    reason = '',
    city = commonData.addressInfo().city,
    login_method = '',
    login_date = new Date(),
    lat = commonData.addressInfo().lat,
    long = commonData.addressInfo().long
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.LOGIN_SUCCESSFUL, {
      status,
      reason,
      city,
      login_method,
      login_date,
      lat,
      long
    });
  },
  update_user: async ({
    mobile_no = '',
    email = '',
    first_name = '',
    registration_date = null,
    gender = '',
    dob = null,
    date_of_update = null
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.UPDATE_USER, {
      mobile_no,
      email,
      first_name,
      registration_date,
      gender,
      dob,
      date_of_update
    });
  },

  redeem_attempt: async ({
    product_id = '',
    product_name = '',
    crown_value = 0,
    offer_id = '',
    id = '',
    image_url = '',
    crown_points = commonData.getCrowns(),
    store_name = commonData.addressInfo().outletName,
    date = null,
    order_mode = commonData.orderMode()
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.REDEEM_ATTEMPT, {
      product_id,
      product_name,
      crown_value,
      offer_id,
      id,
      image_url,
      crown_points,
      store_name,
      date,
      order_mode
    });
  },
  redeem_succesful: async ({
    product_id = '',
    product_name = '',
    crown_value = 0,
    offer_id = '',
    id = '',
    image_url = '',
    message = '',
    crown_points = commonData.getCrowns(),
    store_name = commonData.addressInfo().outletName,
    date = null,
    coupon_code = '',
    order_mode = commonData.orderMode()
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.REDEEM_SUCCESFUL, {
      product_id,
      product_name,
      crown_value,
      offer_id,
      id,
      image_url,
      message,
      crown_points,
      store_name,
      date,
      coupon_code,
      order_mode
    });
  },
  redeem_failed: async ({
    product_id = '',
    product_name = '',
    crown_value = 0,
    offer_id = '',
    id = '',
    image_url = '',
    message = '',
    order_mode = commonData.orderMode()
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.REDEEM_FAILED, {
      product_id,
      product_name,
      crown_value,
      offer_id,
      id,
      image_url,
      message,
      order_mode
    });
  },
  get_crown_offer: async ({
    product_id = '',
    product_name = '',
    crown_value = 0,
    offer_id = '',
    id = '',
    image_url = '',
    crown_points = 0,
    store_name = commonData.addressInfo().outletName,
    date = null,
    order_mode = commonData.orderMode()
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.GET_CROWN_OFFER, {
      product_id,
      product_name,
      crown_value,
      offer_id,
      id,
      image_url,
      crown_points,
      store_name,
      date,
      order_mode
    });
  },
  shake_game: async ({
    crown_points = 0,
    date = null,
    id = '',
    crowns_earned = 0,
    attempt_no = false,
    order_mode = commonData.orderMode()
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.SHAKE_GAME, {
      crown_points,
      date,
      id,
      crowns_earned,
      attempt_no,
      order_mode
    });
  },
  rate_order: async ({
    order_id = '',
    overall_rating = '',
    order_mode = commonData.orderMode(),
    remarks = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.RATE_ORDER, {
      order_id,
      overall_rating,
      order_mode,
      remarks
    });
  },
  recent_orders: async ({
    order_mode = commonData.orderMode(),
    store_name = commonData.addressInfo().outletName,
    store_id = commonData.addressInfo().outletId,
    order_id = '',
    order_value = 0,
    order_date = null,
    coupon_applied = false
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.RECENT_ORDERS, {
      order_mode,
      store_name,
      store_id,
      order_id,
      order_value,
      order_date,
      coupon_applied
    });
  },
  saved_kingdeals: async ({ deal_name = '' }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.SAVED_KINGDEALS, {
      deal_name
    });
  },
  edit_profile: async ({
    city = commonData.addressInfo().city,
    mobile_no = '',
    name = '',
    email = '',
    dob = '',
    gender = '',
    crown_points = commonData.getCrowns()
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.EDIT_PROFILE, {
      city,
      mobile_no,
      name,
      email,
      dob,
      gender,
      crown_points
    });
  },
  crown_history: async ({
    crown_points = commonData.getCrowns(),
    store_name = commonData.addressInfo().outletName,
    region = commonData.addressInfo().region,
    crowns_earned_store_id = commonData.addressInfo().outletId
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.CROWN_HISTORY, {
      crown_points,
      store_name,
      region,
      crowns_earned_store_id
    });
  },
  crown_redeem: async ({
    crown_points = 0,
    store_name = '',
    region = '',
    crown_redeemed_store_id = ''
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.CROWN_REDEEM, {
      crown_points,
      store_name,
      region,
      crown_redeemed_store_id
    });
  },
  settings_support_click: async ({
    button_name = '',
    datetime = new Date()
  }) => {
    trackMoengageEvents(ANALYTICS_EVENTS.SETTINGS_SUPPORT_CLICK, {
      button_name,
      datetime
    });
  },
  call_restaurant: async ({
    order_mode = commonData.orderMode(),
    rider_number = '',
    rider_name = '',
    store_id = commonData.addressInfo().outletId,
    order_id = '',
    id = '',
    crown_points = commonData.getCrowns(),
    store_name = commonData.addressInfo().outletName
  }) => {
    await trackMoengageEvents(ANALYTICS_EVENTS.CALL_RESTAURANT, {
      order_mode,
      rider_number,
      rider_name,
      store_id,
      order_id,
      id,
      crown_points,
      store_name
    });
  },
  call_rider: async ({
    order_mode = '',
    rider_number = '',
    rider_name = '',
    store_id = '',
    order_id = '',
    id = '',
    store_name = '',
    order_value = 0
  }) => {
    await trackMoengageEvents(ANALYTICS_EVENTS.CALL_RIDER, {
      order_mode,
      rider_number,
      rider_name,
      store_id,
      order_id,
      id,
      store_name,
      order_value
    });
  },
  'add-ons': async ({
    cheese_added = false,
    beverage_added = false,
    meal_choosen = false
  }) => {
    await trackMoengageEvents(ANALYTICS_EVENTS.ADD_ONS, {
      cheese_added,
      beverage_added,
      meal_choosen
    });
  },
  registration_succesfull: async ({
    status = '',
    reason = '',
    city = commonData.addressInfo().city,
    login_method = '',
    registration_date = new Date(),
    lat = commonData.addressInfo().lat,
    long = commonData.addressInfo().long,
    name = ''
  }) => {
    await trackMoengageEvents(ANALYTICS_EVENTS.REGISTRATION_SUCCESSFUL, {
      status,
      reason,
      city,
      login_method,
      registration_date,
      lat,
      long,
      name
    });
  }
};

export default MOENGAGE_EVENTS_TRACKER;
